import React from 'react'
import '../styles/LiquidBlockTop.css'
import Page from './Page'

const LiquidBlockTop = ({children, className}) => {
  return (
    <div className='LiqBlockTopBGBG'>
      <Page>
        <div className={`LiqBlockTop ${className || ''}`}>
            <div className='LiqBlockTopBG'>
                {children}
            </div>
        </div>
      </Page>
    </div>
  )
}

export default LiquidBlockTop